import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../store/user/userSlice';
import { readAuthContextFromStorage } from '../../store/user/userService';

const AFFILIATE_ROLES = ['affiliate', 'platform_admin'];

export const AffiliateProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRoles = useSelector((state) => state.user.userRoles);
  const userType = useSelector((state) => state.user.userType);
  const [isReady, setIsReady] = useState(false);

  const checkAccess = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined') {
      return navigate('/login');
    }

    let effectiveRoles = Array.isArray(userRoles) && userRoles.length > 0
      ? userRoles
      : (userType ? [userType] : []);

    if (effectiveRoles.length === 0) {
      const hydrated = readAuthContextFromStorage();
      effectiveRoles = hydrated.roles || (hydrated.user_type ? [hydrated.user_type] : []);
      if (effectiveRoles.length > 0) {
        dispatch(userActions.setAuthContext(hydrated));
      }
    }

    if (!effectiveRoles.some((r) => AFFILIATE_ROLES.includes(r))) {
      return navigate('/dashboard', { replace: true });
    }

    setIsReady(true);
  }, [navigate, dispatch, userRoles, userType]);

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  return <>{isReady ? children : null}</>;
};
